// Update product category data for selectors
export const transformCategories = (categories) => {
  return categories?.map((category) => {
    return {
      ...category,
      subcategories: category?.subcategories?.map((subcategory) => ({
        label: subcategory?.category_name,
        value: subcategory?.category_id,
      })),
    };
  });
};

// Return updated initial product category data?
// export const convertCategoriesArray = (categoriesArray) => {
//   if (!Array.isArray(categoriesArray) || categoriesArray.length === 0) {
//     return null; // Return null or handle empty input as needed
//   }

//   const parentCategoryId = categoriesArray[0]?.categories?.parent_category_id;
//   const subCategories = categoriesArray?.map((item) => ({
//     label: item?.categories?.category_name,
//     value: item?.categories?.category_id,
//   }));

//   return {
//     parent_category_id: parentCategoryId,
//     subCategories,
//   };
// };
const convertCategoriesArray = (categoriesArray) => {
  return categoriesArray.reduce((acc, item) => {
    const parentId = item.categories.parent_category_id;

    if (!acc[parentId]) {
      acc[parentId] = [];
    }

    acc[parentId].push({
      category_id: item.category_id,
      category_name: item.categories.category_name,
      category_icon_path: item.categories.category_icon_path,
      key_information: item.categories.key_information,
    });

    return acc;
  }, {});
};

// Age category
// Helper function to get category name by category ID
export const getAgeCategoryNameById = (categoryId, ageGroupData) => {
  const category = ageGroupData?.find(
    (item) => item.age_group_id === categoryId
  );
  return category ? category.price_category_name : "Unknown Category";
};
